module.exports = __webpack_public_path__ + "static/media/meeting-calender-icon.34be4929.svg";